import { ValidatorOptions } from '.';
import { ValidationResult } from './types.validators';
import { Validator } from './validator';

export class RequiredValidator extends Validator {
    public validate(value: string, options: ValidatorOptions) {
        const { required } = options;
        const trimmedValue = value?.trim();
        if (required && trimmedValue.length < 1) {
            return new ValidationResult(false, 'This field is required');
        }

        return new ValidationResult(true);
    }
}
